import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";

import { getActivities } from "../../reducer";
import { loadActivities, saveActivity } from "../../reducer/actions";
import { getTranslate } from "react-localize-redux";


class ActivityDetail extends Component {


    constructor(props) {
        super(props);
        this.state = {
            name: '',
            displayName: ''
        }
    }

    componentDidMount() {
        this.props.loadActivities().then((activities) => {
            this.prepareActivities()
        });
    }

    componentDidUpdate() {
        //this.prepareActivities();
    }

    prepareActivities() {
        let activity = this.findActivity(this.props.match.params.id);
        if (activity === null || typeof activity === 'undefined') {
            return false;
        }
        this.setState({...activity});
    }


    findActivity(id) {
        for (let i in this.props.activities) {
            if (parseInt(this.props.activities[i].id,10) === parseInt(id,10)) {
                return this.props.activities[i];
            }
        }
        return null;
    }

    render() {
        return (

            <Segment style={{padding: '8em 0em'}} vertical>
                <Grid container stackable verticalAlign='middle' centered>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Header as='h2' color='teal' textAlign='center'>
                                {this.props.translate('admin.user.edit.header')}
                            </Header>
                            <Form size='large' onSubmit={() => {
                                this.props.saveActivity(this.state)
                            }}>
                                <Segment stacked>
                                    <Form.Input
                                        label={this.props.translate('general.name')}
                                        fluid
                                        icon='user'
                                        iconPosition='left'
                                        placeholder={this.props.translate('general.name')}
                                        type={'text'}
                                        value={this.state.name}
                                        onChange={(e) => {
                                            this.setState({name: e.target.value})
                                        }}
                                    />

                                    <Form.Input
                                        label={this.props.translate('general.displayName')}
                                        fluid
                                        icon='user'
                                        iconPosition='left'
                                        placeholder={this.props.translate('general.displayName')}
                                        type={'text'}
                                        value={this.state.displayName}
                                        onChange={(e) => {
                                            this.setState({displayName: e.target.value})
                                        }}
                                    />

                                    <Button type='submit'>{this.props.translate('general.save')}</Button>
                                </Segment>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        );
    }

}


const mapStateToProps = state => {
    return {
        activities: getActivities(state.admin),
        translate: getTranslate(state.localize),
    }
};

const mapDispatchToProps = (dispatch) => {
    return ({
        loadActivities: () => {
            return dispatch(loadActivities())
        },
        saveActivity: (activity) => {
            return dispatch(saveActivity(activity))
        },
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ActivityDetail)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/ActivityDetail/index.js